import { render, staticRenderFns } from "./CadastroPatrimonioForm.vue?vue&type=template&id=f081bb24"
import script from "./CadastroPatrimonioForm.vue?vue&type=script&lang=js"
export * from "./CadastroPatrimonioForm.vue?vue&type=script&lang=js"
import style0 from "./../../../../../components/editor/style-editor.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports